var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17871 34H8.15039L10.4355 27.6367H11.5518L13.8457 34H12.8174L12.2373 32.3213H9.75879L9.17871 34ZM10.0356 31.5127H11.9561L11.0156 28.7969H10.9717L10.0356 31.5127ZM15.6211 27.6367V34H14.6543V27.6367H15.6211ZM22.6436 28.1729V28.8496H18.7324V28.1729H20.2793V27.1006H21.1055V28.1729H22.6436ZM18.9873 31.1348C18.9829 30.0757 19.7036 29.3242 20.6924 29.3242C21.6899 29.3242 22.4019 30.0757 22.4062 31.1348C22.4019 32.2114 21.6899 32.9673 20.6924 32.9629C19.7036 32.9673 18.9829 32.2114 18.9873 31.1348ZM19.7256 31.1348C19.7212 31.8027 20.1255 32.251 20.6924 32.251C21.2593 32.251 21.668 31.8027 21.668 31.1348C21.668 30.48 21.2593 30.0229 20.6924 30.0186C20.1255 30.0229 19.7212 30.48 19.7256 31.1348ZM23.0039 34.3779V27.0479H23.7949V30.1504H24.7002V26.8721H25.4912V34.7471H24.7002V30.8359H23.7949V34.3779H23.0039ZM33.0938 26.8721V30.9238H32.2588V28.9023H30.5977V28.2256H32.2588V26.8721H33.0938ZM26.502 30.291C27.7324 29.8999 28.4663 28.9199 28.4707 27.8125V27.127H29.2969V27.8125C29.2969 28.8145 30.0176 29.7461 31.2041 30.124L30.7646 30.7744C29.8989 30.4756 29.2441 29.8823 28.897 29.1309C28.5542 29.979 27.8818 30.6382 26.9502 30.959L26.502 30.291ZM27.9434 31.9521V31.293H33.0938V33.2529H28.7783V33.9824H33.3662V34.6504H27.9609V32.6201H32.2676V31.9521H27.9434Z",
    fill: "#43494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6757 8.46191H14.3241C13.0403 8.46191 11.9995 9.50268 11.9995 10.7865V21.2133C11.9995 22.4971 13.0403 23.5379 14.3241 23.5379H27.6757C28.9595 23.5379 30.0003 22.4971 30.0003 21.2133V10.7865C30.0003 9.50268 28.9595 8.46191 27.6757 8.46191Z",
    fill: "url(#paint0_linear_144_8071)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3815 12.2714C20.6613 11.7913 19.8011 11.5112 18.8729 11.5112C16.3762 11.5112 14.3477 13.5398 14.3477 16.0364C14.3477 18.5331 16.3762 20.5616 18.8729 20.5616C19.8011 20.5616 20.6613 20.2816 21.3815 19.8014V20.3856H23.4381V11.6873H21.3815V12.2714ZM18.8729 18.5051C17.5125 18.5051 16.4042 17.3968 16.4042 16.0364C16.4042 14.6761 17.5125 13.5678 18.8729 13.5678C20.2332 13.5678 21.3415 14.6761 21.3415 16.0364C21.3415 17.3968 20.2332 18.5051 18.8729 18.5051Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4115 11.5071H25.355V20.5575H27.4115V11.5071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_8071",
    x1: 13.4119,
    y1: 23.5859,
    x2: 28.5879,
    y2: 8.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#07E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#13BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1D9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2483FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2875FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A71FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A76FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2A84F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2A9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2BBED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CE9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPrompt);
export default __webpack_public_path__ + "static/media/ai-prompt.8cedc891811f4e377e254fc4d779c72c.svg";
export { ForwardRef as ReactComponent };